var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "channel-search-dialog",
      attrs: {
        title: "命中渠道",
        visible: _vm.dialogIsShow,
        width: "1000px",
        "append-to-body": true,
        "destroy-on-close": true,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogIsShow = $event
        },
        open: _vm.openCallback,
        close: _vm.closeCallback,
      },
    },
    [
      _c(
        "div",
        { staticClass: "dialog-body" },
        [
          _c(
            "el-form",
            {
              ref: "formRef",
              staticClass: "dialog-form",
              attrs: {
                model: _vm.form,
                "label-width": "120px",
                rules: _vm.formRule,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "命中渠道：", prop: "channelId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: "请输入渠道名称进行搜索",
                        filterable: "",
                        clearable: "",
                        remote: "",
                        "remote-method": _vm.remoteMethod,
                        loading: _vm.isLoadingChannelOptions,
                      },
                      model: {
                        value: _vm.form.channelId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "channelId", $$v)
                        },
                        expression: "form.channelId",
                      },
                    },
                    _vm._l(_vm.channelOptions, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: {
                          label: `(${item.id}) ${item.name}`,
                          value: item.id,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "版本号：", prop: "apkVersion" } },
                [
                  _c("el-input-number", {
                    staticClass: "version-input",
                    staticStyle: { width: "100%" },
                    attrs: {
                      min: 0,
                      placeholder: "输入应用版本，正整数",
                      controls: false,
                    },
                    model: {
                      value: _vm.form.apkVersion,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "apkVersion", $$v)
                      },
                      expression: "form.apkVersion",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "协议版本号：", prop: "protocolVersion" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.protocolVersion,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "protocolVersion", $$v)
                        },
                        expression: "form.protocolVersion",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("老版本"),
                      ]),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("新版本"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "设备UID：" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入设备UID" },
                    model: {
                      value: _vm.form.uid,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "uid", $$v)
                      },
                      expression: "form.uid",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-button",
            {
              staticStyle: { "margin-bottom": "16px" },
              attrs: { type: "primary" },
              on: { click: _vm.handleQuery },
            },
            [_vm._v("发起查询")]
          ),
          _c("el-input", {
            attrs: { type: "textarea", rows: 10, readonly: true },
            model: {
              value: _vm.searchResult,
              callback: function ($$v) {
                _vm.searchResult = $$v
              },
              expression: "searchResult",
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }